const path = require("path");

module.exports = {
  i18n: {
    locales: ["en", "fr"],
    defaultLocale: "en",
    localeDetection: false,
    fallbackNS: "common",
  },
  // localePath: path.resolve("./public/static/locales"),
  localePath: path.resolve("./public/locales"),
  react: { useSuspense: false }, // this line
  serializeConfig: false,
  reloadOnPrerender: process.env.NODE_ENV === "development",
};
